<script lang="ts">
  import { changePassword, ApiError } from "../lib/api";
  import { clearMustChangePassword } from "../lib/session.svelte";

  let current = "";
  let next = "";
  let confirm = "";
  let error: string | null = null;
  let busy = false;

  async function submit() {
    error = null;
    if (!current || !next) {
      error = "current and new password required";
      return;
    }
    if (next !== confirm) {
      error = "new passwords do not match";
      return;
    }
    busy = true;
    try {
      await changePassword({ current_password: current, new_password: next });
      clearMustChangePassword();
    } catch (err) {
      error =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : "change failed";
    } finally {
      busy = false;
    }
  }
</script>

<div class="gate" data-testid="must-change-password">
  <div class="card">
    <h1>Change your password</h1>
    <p class="hint">
      Your account requires a new password before you can continue.
    </p>
    {#if error}<p class="error" data-testid="error">{error}</p>{/if}
    <input
      type="password"
      placeholder="current password"
      bind:value={current}
      data-testid="current-password"
    />
    <input
      type="password"
      placeholder="new password"
      bind:value={next}
      data-testid="new-password"
    />
    <input
      type="password"
      placeholder="confirm new password"
      bind:value={confirm}
      data-testid="confirm-password"
    />
    <button on:click={submit} disabled={busy} data-testid="submit">
      {busy ? "Saving…" : "Change password"}
    </button>
  </div>
</div>

<style>
  .gate {
    position: fixed;
    inset: 0;
    display: grid;
    place-items: center;
    background: rgba(15, 23, 42, 0.92);
    z-index: 50;
  }
  .card {
    display: grid;
    gap: 0.6rem;
    width: min(360px, 90vw);
    padding: 1.5rem;
    background: #111827;
    border: 1px solid #1f2937;
    border-radius: 10px;
  }
  h1 {
    margin: 0;
    font-size: 1.2rem;
  }
  .hint {
    margin: 0;
    font-size: 0.85rem;
    color: #9ca3af;
  }
  input {
    padding: 0.5rem;
    background: #0f172a;
    color: #f3f4f6;
    border: 1px solid #1f2937;
    border-radius: 4px;
  }
  button {
    padding: 0.5rem 0.7rem;
    background: #10b981;
    color: #04211a;
    border: none;
    border-radius: 6px;
    font-weight: 600;
  }
  button:disabled {
    opacity: 0.6;
  }
  .error {
    margin: 0;
    color: #fca5a5;
    font-size: 0.85rem;
  }
</style>
